import React from 'react';
import { motion } from 'framer-motion';

export default function StatBar({ label, value, max = 100, colorClass = "bg-cyan-500" }) {
  const percentage = Math.min((value / max) * 100, 100);
  
  return (
    <div className="mb-4">
      <div className="flex justify-between text-xs font-mono mb-1">
        <span className="text-zinc-400 uppercase tracking-widest">{label}</span>
        <span className="text-zinc-100">{value} / {max}</span>
      </div>
      <div className="h-1.5 bg-zinc-900 rounded-full overflow-hidden border border-zinc-800">
        <motion.div 
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className={`h-full ${colorClass} relative`}
        >
          <div className="absolute inset-0 bg-white/20 w-full animate-[shimmer_2s_infinite]" />
        </motion.div>
      </div>
    </div>
  );
}